module.exports = __webpack_public_path__ + "img/impressive_jewelry@2x.34b6c07.jpg";